<template>
  <el-dialog class="k-starts-organizer-edit-form" :title="organizer && organizer._id ? `Редашування організатора ${organizer._id}` : 'Добавление нового старта'" :visible.sync="dialogFormVisible">
    <div class="k-starts-organizer-edit-form__container">
      <p class="k-starts-organizer-edit-form__title">Ви можете відредагувати інформацію про організатора старта та зберегти її у базі даних:</p>

      <el-row :gutter="20" class="k-starts-organizer-edit-form__param">
        <el-col :span="8" class="k-starts-organizer-edit-form__label">Назва:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-starts-organizer-edit-form__param">
        <el-col :span="8" class="k-starts-organizer-edit-form__label">URL логотипу:</el-col>
        <el-col :span="16"><el-input placeholder="Назва файла з логотипом" v-model="logoUrl"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-starts-organizer-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Зберегти</el-button>
        <el-button round @click="handleCancel" size="mini">Відміна</el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
/**
 * Component: k-starts-organizer-edit-form - Форма для редактирования информации о токене
*
* @version 1.0.0
*/

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-starts-organizer-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type:Boolean,
      required: true,
    },

    // Данные для отображения
    organizer: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      title: '',
      logoUrl: '',
    };
  },

  computed: {
    ...mapGetters({
      startsCategories: 'settings/startsCategories',
    }),
  },

  watch: {
    organizer: {
      handler: function(newValue) {
        this.setStartsOrganizerData();
      },
      deep: true,
    },
  },

  async created() {
    if (this.organizer) {
      this.setStartsOrganizerData();
    }
  },

  methods: {
    setStartsOrganizerData() {
      this.title = this.organizer.title ? this.organizer.title : '';
      this.logoUrl = this.organizer.logoUrl ? this.organizer.logoUrl : '';
    },

    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о токене на бекенде
    async handleSave() {
      const organizer = {
        title: this.title,
        logoUrl: this.logoUrl,
      };

      if (this.organizer._id) {
        organizer._id = this.organizer._id;
      }

      await this.setStartsOrganizer(organizer);
      this.$emit('update');
    },

    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },

    ...mapActions({
      setStartsOrganizer: 'starts/setStartsOrganizer',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-starts-organizer-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
}
</style>
